export default __webpack_public_path__ + "navigation-examples-route-init-thumbnail-v1-480-ebcd5074d8eedc8b03a4d4d671f87033.webp";